// extracted by mini-css-extract-plugin
module.exports = {"container":"ColoredPageHeading_container__38Snc","heading":"ColoredPageHeading_heading__3IfoB","sending":"ColoredPageHeading_sending__E7wMX"};